const DEFAULT_TITLE = 'Ювелирные калькуляторы онлайн — расчёт веса, пробы и металла'
const DEFAULT_DESCRIPTION = 'Бесплатные ювелирные калькуляторы: расчёт лигатуры, припоя, цепочек, шинки, трубки, восковки, веса по объёму и смешивания проб.'
const SITE_ORIGIN = 'https://jewelerhelper.site'

const setMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    document.head.appendChild(element)
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value))
}

const setCanonical = (url) => {
  let canonical = document.head.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.rel = 'canonical'
    document.head.appendChild(canonical)
  }
  canonical.href = url
}

const setStructuredData = (url, title, description) => {
  let script = document.head.querySelector('#application-structured-data')
  if (!script) {
    script = document.createElement('script')
    script.id = 'application-structured-data'
    script.type = 'application/ld+json'
    document.head.appendChild(script)
  }
  script.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: title,
    description,
    url,
    applicationCategory: 'UtilitiesApplication',
    operatingSystem: 'Web',
    inLanguage: 'ru',
    isAccessibleForFree: true,
  })
}

export const updateSeo = (route) => {
  const title = route.meta.title || DEFAULT_TITLE
  const description = route.meta.description || DEFAULT_DESCRIPTION
  const canonicalUrl = `${SITE_ORIGIN}${route.path || '/'}`
  const robots = route.meta.noindex ? 'noindex, nofollow' : 'index, follow'

  document.title = title
  setMeta('meta[name="description"]', { name: 'description', content: description })
  setMeta('meta[name="robots"]', { name: 'robots', content: robots })
  setMeta('meta[property="og:title"]', { property: 'og:title', content: title })
  setMeta('meta[property="og:description"]', { property: 'og:description', content: description })
  setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' })
  setMeta('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl })
  setMeta('meta[property="og:locale"]', { property: 'og:locale', content: 'ru_RU' })
  setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: 'Ювелирные калькуляторы' })
  setCanonical(canonicalUrl)
  setStructuredData(canonicalUrl, title, description)
}
